export default __webpack_public_path__ + "static/media/1164.d03e3b4a.png";